// utils/encryption.ts
import CryptoJS from 'crypto-js';

const secretKey = process.env.SECRET_ENCRYPTION_KEY || '12345678901234567890123456789012'; 

// Encrypt text
export function encrypt(text: string): string {
  const ciphertext = CryptoJS.AES.encrypt(text, secretKey).toString();
  return ciphertext;
}

// Decrypt text
export function decrypt(encryptedText: string): string {
  const bytes = CryptoJS.AES.decrypt(encryptedText, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
}

